import { render, staticRenderFns } from "./DeliveryRecap.vue?vue&type=template&id=fc5287fe"
import script from "./DeliveryRecap.vue?vue&type=script&lang=ts"
export * from "./DeliveryRecap.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryRecap.vue?vue&type=style&index=0&id=fc5287fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports